import { _get } from "./Axios";

export default class LaporanGabunganApi {
  static getListKpi(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("report/gabungan?" + params);
  }

  static getDetailKpi(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("report/gabungan/sub?" + params);
  }

  static getDetailSubKpi(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("report/gabungan/sub/detail?" + params);
  }

  static getListKonsolidasi(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("report/gabungan/monitoring-konsolidasi?" + params);
  }
}
